<template>
  <div class="zsyz-page def-w">
    <div class="filter-content">
      <div class="filter-list">
        <div class="filter-item flex">
          <span class="filter-label">招商类型:</span>
          <ul class="flex filter-option-list">
            <li
              v-for="(item, index) in typeList"
              :key="index"
              class="filter-option"
              :class="{ active: item.attractCode === searchForm.attractType }"
              @click="selFilter('attractType', item.attractCode)"
            >
              {{ item.attractName }}
            </li>
          </ul>
        </div>
        <div class="filter-item flex">
          <span class="filter-label">项目状态:</span>
          <ul class="flex filter-option-list">
            <li
              v-for="(item, index) in statusList"
              :key="index"
              class="filter-option"
              :class="{ active: item.code === searchForm.projectStatus }"
              @click="selFilter('projectStatus', item.code)"
            >
              {{ item.label }}
            </li>
          </ul>
        </div>
      </div>
      <div class="filter-total">
        <span class="color-666 fl">
          当前记录
          <em class="color-theme-red">{{ total }}</em>
          条
        </span>
      </div>
    </div>
    <div class="page-container">
      <div v-if="list.length" v-loading="loading">
        <zsyz-list :list="list" />
      </div>
      <div v-else-if="!loading" style="height: 450px">
        <no-data />
      </div>
      <el-pagination
        class="table-pagination flex-center"
        hide-on-single-page
        background
        :current-page="curPage"
        :page-size="16"
        :pager-count="5"
        prev-text="上一页"
        next-text="下一页"
        layout=" prev, pager, next, slot"
        :total="total"
        @current-change="handleCurrentChange"
      >
        <div class="flex align-center color-666">
          <div>共{{ curPage }}页/共{{ total }}条数据</div>
          <div class="flex-center ml-20">
            <p>转到</p>
            <el-input-number
              v-model="curSdPage"
              class="page-input"
              :controls="false"
              :min="1"
              :max="maxPage"
              :step="1"
              step-strictly
            />
            <p class="ml-5">页</p>
            <el-button class="jump-btn" @click="handleCurrentChange(curSdPage)">
              确定
            </el-button>
          </div>
        </div>
      </el-pagination>
    </div>
  </div>
</template>

<script>
import ZsyzList from "./components/zsyz-list.vue";
import NoData from "@/components/NoData.vue";
import zsyzApi from "@/api/zsyz";
import { ZSYZ_OPTIONS } from "@/utils/constant";

export default {
  components: {
    ZsyzList,
    NoData
  },
  props: {},
  data() {
    return {
      typeList: [],
      statusList: ZSYZ_OPTIONS,
      searchForm: {
        attractType: "",
        projectStatus: ""
      },
      list: [],
      curPage: 1,
      curSdPage: 1,
      total: 0,
      loading: false
    };
  },
  computed: {
    maxPage() {
      return Math.ceil(this.total / this.pageSize);
    }
  },
  async created() {
    await this.getTypeList();
    this.getData();
  },
  mounted() {},
  methods: {
    // 获取招商类型
    async getTypeList() {
      const res = await zsyzApi.type();
      if (res.data && res.data.length) {
        this.typeList = [{ attractName: "全部", attractCode: "" }, ...res.data];
      }
    },
    // 获取数据
    getData() {
      const params = {
        pageNo: this.curPage,
        pageSize: 16,
        ...this.searchForm
      };
      zsyzApi.page(params).then((res) => {
        if (res.data && res.data.list) {
          this.list = res.data.list || [];
          this.total = res.data.total || 0;
        }
      });
    },
    // 选取条件
    selFilter(type, val) {
      this.searchForm[type] = val;
      this.curPage = 1;
      this.getData();
    },
    // 翻页
    handleCurrentChange(val) {
      this.curPage = Number(val);
      this.getData();
    }
  }
};
</script>

<style scoped lang="scss">
.zsyz-page {
  padding-bottom: 30px;

  .filter-content {
    padding: 0 10px;
    background-color: #fff;
    border: 1px solid #ddd;
    .filter-list {
      padding: 20px 10px;
      .filter-item {
        .filter-label {
          width: 90px;
          min-width: 90px;
          text-align: right;
          color: #666;
          font-size: 14px;
        }
        .filter-option-list {
          margin-left: 20px;
          flex-wrap: wrap;
          .filter-option {
            height: 24px;
            line-height: 22px;
            padding: 0 10px;
            border: 1px solid #fff;
            border-radius: 24px;
            margin: 0 10px 10px 0;
            cursor: pointer;
            &:hover {
              color: $--color-primary;
              border-color: $--color-primary;
            }
          }
          .active {
            color: $--color-primary;
            border-color: $--color-primary;
          }
        }
      }
      .filter-item + .filter-item {
        margin-top: 10px;
      }
    }
    .filter-total {
      border-top: 1px dashed #ddd;
      height: 50px;
      padding: 12px 0 0 0;
    }
  }

  .page-container {
    .table-pagination {
      margin-top: 35px;
      ::v-deep {
        .el-pager li {
          width: 34px;
          height: 34px;
          line-height: 34px;
          background-color: #fff;
          color: #666;
          border: 1px solid #ddd;
        }
        .btn-prev,
        .btn-next {
          width: 70px;
          height: 34px;
          background-color: #fff;
          color: #666;
          border: 1px solid #ddd;
        }
        .btn-next {
          margin-right: 10px;
        }
      }
      .page-input {
        width: 60px;
        margin-left: 5px;
        ::v-deep .el-input__inner {
          height: 33px;
          padding: 0 5px;
        }
      }
      .jump-btn {
        width: 50px;
        height: 33px;
        background: $--color-primary;
        border-radius: 0;
        margin-left: 10px;
        color: #fff;
      }
    }
  }
}
</style>
